const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M254.4,151.6v72.8c0,16.5-12.8,29.9-28.6,29.9H30.2c-15.7,0-28.6-13.4-28.6-29.9v-72.8c0-5.8,4.7-10.5,10.5-10.5s10.5,4.7,10.5,10.5v72.8c0,4.9,3.4,8.9,7.5,8.9h195.6c4.1,0,7.5-4,7.5-8.9v-72.8c0-5.8,4.7-10.5,10.5-10.5s10.5,4.7,10.5,10.5h0Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6,92.3c2.8,0,5.5-1.1,7.4-3.1l51.5-51.5v131.8c0,5.8,4.7,10.5,10.6,10.5h0c5.8,0,10.5-4.7,10.5-10.5V37.7s51.4,51.5,51.4,51.5c4.1,4.1,10.8,4.1,14.9,0,4.1-4.1,4.1-10.8,0-14.9L135.5,4.8c-.1-.1-.3-.2-.4-.4h-.2c0-.2-.1-.3-.2-.3h0c0,0,0-.1-.1-.1h0s-.2-.2-.2-.2h0s-.1-.1-.1-.1h0c0,0-.1-.2-.1-.2h0s-.1-.1-.1-.1h-.1c0,0-.1-.2-.1-.2h0s0,0,0,0h-.1c0,0-.2-.2-.2-.2h0s0,0,0,0h-.1c0,0-.2-.2-.2-.2h0s0,0,0,0h-.1c0,0-.2-.2-.2-.2h0s0,0,0,0h-.1s-.3-.1-.3-.1h0s-.1,0-.1,0c0,0-.2,0-.3,0h-.2c0,0-.3-.1-.3-.1h-.2s-.3-.1-.3-.1h-.2s-.3,0-.3,0h-.2s-.3,0-.3,0h-.3s-.2,0-.2,0c-.4,0-.7,0-1.1,0h-.5s-.3,0-.3,0h-.2s-.3,0-.3,0h-.2s-.3.1-.3.1h-.1s0,0,0,0c-.1,0-.2,0-.3,0h-.1s0,0,0,0h-.3c0,0-.2.1-.2.1h0s-.3.1-.3.1h-.2c0,0,0,0,0,0h-.2c0,0-.2.2-.2.2h0s-.2.1-.2.1h-.2c0,.1,0,.1,0,.1h-.2c0,.1-.1.2-.2.2h0s-.1.1-.1.1h-.2c0,.1,0,.2,0,.2h-.1c0,0-.2.3-.2.3h0s-.2.2-.2.2l-.2.2h0c0,0-.1.1-.2.2l-.2.2s0,0,0,0c-.1,0-.2.2-.3.3h0c0,0-69.4,69.5-69.4,69.5-4.1,4.1-4.1,10.8,0,14.9,2,2,4.7,3.1,7.5,3.1h0Z",
    style: {
      fill: "#f22",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.f357d0a32163ddb4a20b191d63fe7fd1.svg";
export { ForwardRef as ReactComponent };